const BACKEND = process.env.REACT_APP_BACKEND_URL;

const ENDPOINTS = {
  "project-inquiry": "/api/contact",
  "talent-network": "/api/careers",
  "chat-message": "/api/chat",
};

/**
 * Dual-capture submit:
 * 1. POST to the FastAPI backend when one is configured (full-stack deploys).
 * 2. Always also POST to "/" so Netlify Forms captures the submission whenever
 *    the site is deployed on Netlify (harmless no-op elsewhere).
 * Succeeds if either path accepts the submission.
 */
export async function submitForm(formName, formData) {
  formData.append("form-name", formName);

  // FormData bodies are safe to reuse across requests
  let backendOk = false;
  if (BACKEND) {
    try {
      const res = await fetch(`${BACKEND}${ENDPOINTS[formName] || "/api/contact"}`, {
        method: "POST",
        body: formData,
      });
      backendOk = res.ok;
    } catch (e) {
      /* backend unreachable — Netlify path still runs */
    }
  }

  let netlifyOk = false;
  try {
    // Post to a dedicated static file so the SPA catch-all rewrite never
    // swallows the submission before Netlify's forms engine sees it.
    const hasFile = [...formData.values()].some(
      (v) => typeof File !== "undefined" && v instanceof File && v.size > 0
    );
    let res;
    if (hasFile) {
      // File uploads must be multipart (Netlify requirement)
      res = await fetch("/forms.html", { method: "POST", body: formData });
    } else {
      // URL-encoded is Netlify's documented AJAX submission format
      const params = new URLSearchParams();
      formData.forEach((v, k) => {
        if (typeof v === "string") params.append(k, v);
      });
      res = await fetch("/forms.html", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: params.toString(),
      });
    }
    netlifyOk = res.ok;
  } catch (e) {
    /* offline */
  }

  return { ok: backendOk || netlifyOk };
}

export const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
